import React from 'react';
import styles from '../../assets/styles/Login/Login.module.scss';
import LeftSide from '../pageComponents/LeftSide';
import SignupForm from './SignupForm';
import { IoArrowBackCircle } from "react-icons/io5";
import { MimaText } from '../../components';

function Signup({ validationSchema, onSubmit, loading, hasReferral, refInputHandler, switchToLogin, referrerCode, step, stepOne, stepTwo }) {
	return (
		<div className={styles.container}>
			<LeftSide title="Welcome :)" />
			<div className={styles.rightside}>
				{ step === "stepOne" ?
					(
						<div className={styles.logintext__center}>
							<h3 className={`${styles.logintext__title} ${styles.mb_10}`}>
								{' '}
								Sign Up{' '}
							</h3>
							<p className={styles.logintext__p}>
								Already have an account?{' '}
								<span className={styles.clickable} onClick={switchToLogin}>
									Log in
								</span>
							</p>
						</div>
					) 
					: 
					(
						<div className={styles.rightside__back}>
							<IoArrowBackCircle onClick={stepOne}/>
							<MimaText>Go Back</MimaText>
						</div>
					)
				}
				<div className={styles.loginform}>
					<SignupForm
						refInputHandler={refInputHandler}
						validationSchema={validationSchema}
						onSubmit={onSubmit}
						loading={loading}
						hasReferral={hasReferral}
						referrerCode={referrerCode}
						step={step}
						stepOne={stepOne}
						stepTwo={stepTwo}
					/>
				</div>
				{ step === "stepTwo" ?
					<div className={styles.logintext__p}>
						Creating an account means you agree with <br />{' '}
						<span className={styles.clickable}>
							{' '}
							Mima’s Terms of Service and Privacy Policy
						</span>
					</div> : ''
				}
			</div>
		</div>
	);
}

export default Signup;
